export class EnumMappingItem<TSource, TDestination> {
  source: TSource;
  destination: TDestination;
}

export class EnumMapper<TSource, TDestination> {
  constructor(private readonly mapping: EnumMappingItem<TSource, TDestination>[]) {}

  convertSourceToDestination = (value: TSource): TDestination | null => {
    const element = this.mapping.find((item) => item.source === value);

    if (!element) {
      return null;
    }

    return element.destination;
  };

  convertDestinationToSource = (value: TDestination): TSource | null => {
    const element = this.mapping.find((item) => item.destination === value);

    if (!element) {
      return null;
    }

    return element.source;
  };
}
